export enum CookieKeys {
  AttachmentIdsForBulkEdit = 'attachment-ids-for-bulk-edit',
  BillyApiAccessToken = 'billy_api_accessToken',
  BillyApiAccessTokenStaging = 'billy_api_staging_accessToken',
  BillyApiExternalToken = 'billy_api_external_token',
  BillyApiExternalTokenStaging = 'billy_api_staging_external_token',
  BulkQuery = 'bulk-query',
  FirstSignin = 'first-signin',
  InvoicesListQuery = 'invoices-list-query',
  InvoiceViewRegisterPaymentRequest = 'invoice-view-register-payment-request',
  InvoicingInvoicesListQuery = 'invoicing-invoices-list-query',
  InvoicingRecurringInvoicesListQuery = 'invoicing-recurring-invoices-list-query',
  QuotesListQuery = 'quotes-list-query',
  RecurringInvoicesListQuery = 'recurring-invoices-list-query',
  TransactionsListQuery = 'transactions-list-query',
}
